<template>
  <div class="locale-selector" @mouseleave="hideLocalesMenu">
    <div class="flex items-center pb-5 -mb-5">
    <span class="current-locale capitalize" @mouseover="showLocalesMenu">{{ locale }}</span>
    <span class="material-icons material-icons-caret cursor-pointer ml-auto">
        keyboard_arrow_down
    </span>
    </div>
    <div class="locales-menu" v-show="showMenu">
      <div v-for="(supportedLocale, locale) in supportedLocales">
        <a
          :href="localizeUrl(locale)"
          :hreflang="locale"
          class="capitalize"
        >
          {{ locale }}
        </a>
      </div>
    </div>
  </div>


</template>

<script>
import { goToRouteWithName } from '../../../aula/mixins';

export default {
  mixins: [goToRouteWithName],
   props: {
      supportedLocales: Object,
      locale: {
        type: String,
        required: true,
      },
    },
  data() {
    return {
      showMenu: false,
    };
  },

  methods: {
    showLocalesMenu() {
      this.showMenu = true;
    },
    hideLocalesMenu() {
      this.showMenu = false;
    },
    localizeUrl(locale) {
      const currentPath = this.$router.app.$route.fullPath;
      const newPath = currentPath.replace(/^\/\w+/, `/${locale}`);
      return newPath;
    }
  },
};
</script>

<style scoped lang="scss">
@import '~sass/variables';
.locale-selector {
  position: relative;
}

.current-locale {
  cursor: pointer;
  color: #333;
}

.locales-menu {
  position: absolute;
  top: 35px;
  left: -30px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 5px 0;
}

.locales-menu a {
  display: block;
  padding: 8px 20px 8px 25px;
  text-decoration: none;
  color: #333;
}

.locales-menu a.active {
  font-weight: bold;
}

.locales-menu :hover {
  background: #f0f0f4;
  display: block;

}
.locale-selector:hover  .material-icons-caret {
  transform: rotateX(180deg);
}

.material-icons-caret {
    color: #333;
}


</style>
